//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

module.exports = {
    USECASEIDS: require('./USECASEIDS'),
    dataDictionaryService: require('./dataDictionaryService'),
    routeAccessService: require('./routeAccessService'),
    roleAccessService: require('./roleAccessService'),
    swaggerService: require('./swaggerService'),
    openApiService: require('./openApiService'),
    rfidEnabledRelations: require('./rfidEnabledRelations'),
};


